import axios from 'axios'
import config from '../../constants/endpoints'
import getHeaders from '../helpers/headers'

const {
  endpoints: {
    marketing: { tickets: url },
  },
} = config

/**
 * Filter tickets
 */
export const getTickets = (params) =>
  axios({
    url,
    method: 'get',
    headers: getHeaders(true),
    params,
  })

/**
 * Filter tickets with advanced filters
 */
export const getAdvancedFilteredTickets = (advancedFilters) =>
  axios({
    url,
    method: 'post',
    headers: getHeaders(true),
    data: advancedFilters,
  })
